<template>
  <section class="generic-input">
    <div class="floating-label">
      <input class="input" v-model="newInputValue" :id="idAndName" :type="inputType"
             :placeholder="placeholder" :name="idAndName"
             :disabled="isDisabled" @blur="updateNewValue"/>
      <label v-if="newInputValue && newInputValue.length > 0"
             :for="idAndName"
             :class="{'disabled': isDisabled}">
        {{ placeholder }}
      </label>
      <div v-if="error !== ''"
           :id="idAndName + '-error'"
           class="help has-text-danger error">
        {{ error }}
      </div>
    </div>
  </section>
</template>

<script>

import genericComponentMixin from './mixin'

export default {
  name: 'genericInput',
  props: {
    value: [String, Number],
    placeholder: String,
    inputName: String,
    error: String,
    width: String,
    isDisabled: Boolean,
    valueType: String
  },
  mixins: [genericComponentMixin],
  data: function () {
    return {
      newInputValue: this.value
    }
  },
  watch: {
    value: function () {
      this.newInputValue = this.value
    }
  },
  computed: {
    inputType: function () {
      return this.valueType ? this.valueType : 'text'
    }
  },
  methods: {
    updateNewValue: function () {
      this.$emit('input', this.newInputValue)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  $input-background-color: #FFFFFF;
  $input-height: 45px;
  .generic-input {
    margin: 0 auto 0.5rem;
  }
  .input {
    height: $input-height;
    font-size: 0.85rem;
    box-shadow: none;
    background-color: $input-background-color;
    font-family: 'Roboto';
    &::placeholder {
      color: $grey-light;
      opacity: 1;
    }
    &:focus {
      border: 1px solid lighten($primary, 10%);
      box-shadow: 0 0 0 0.125em lighten($primary, 40%);
    }
  }
  .floating-label {
    position: relative;
    label {
      position: absolute;
      top: calc(50% - 9.5px);
      left: 11px;
      opacity: 0;
      transition: all .3s ease;
      font-size: 0.75rem;
      font-family: 'Roboto';
      color: $grey-light;
    }
    input {
      transition: all .1s ease;
      height: 45px;
      display: block;
    }
    input:not(:placeholder-shown) + label {
      transform: translateY(-10px);
      opacity: .8;
    }
    input:not(:placeholder-shown) {
      padding-top: 36px;
      padding-bottom: 16px;
    }
  }
  .disabled {
    cursor: not-allowed;
  }
</style>
